export default __webpack_public_path__ + "static/media/linkitlogo.f7f9348f.jpeg";